import React, { useEffect, useRef, useState } from 'react';
import { NavLink, useMatch } from 'react-router-dom';
import { buildCondominioNav } from '../nav/condominioNav';

export default function Layout({ gcMe, onLogout, children }) {
  const match = useMatch('/c/:cid/*');
  const ingresosMatch = useMatch({ path: '/c/:cid/cobranza', end: false });
  const storedCid = typeof window !== 'undefined' ? localStorage.getItem('gc_condominio_id') : '';
  const activeCid = match?.params?.cid || storedCid;
  const { primary, more } = buildCondominioNav({ cid: activeCid, gcMe });
  const [moreOpen, setMoreOpen] = useState(false);
  const moreRef = useRef(null);

  const navClass = ({ isActive }) => (isActive ? 'active' : '');

  useEffect(() => {
    const onDoc = (e) => {
      if (moreRef.current && !moreRef.current.contains(e.target)) setMoreOpen(false);
    };
    document.addEventListener('click', onDoc);
    return () => document.removeEventListener('click', onDoc);
  }, []);

  return (
    <div className="app-shell">
      <header className="topbar topbar-main">
        <div className="topbar-brand">
          <strong>Gastos Comunes</strong>
        </div>

        <nav className="nav-global nav-condo-primary" aria-label="Principal">
          <NavLink to="/condominios" end className={navClass}>
            Condominios
          </NavLink>
          {gcMe?.isSuperAdminGc && (
            <NavLink to="/admin" className={navClass}>
              Admin
            </NavLink>
          )}
          {activeCid &&
            primary.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.end} className={navClass}>
                {item.label}
              </NavLink>
            ))}
          {activeCid && more.length > 0 && (
            <div className="nav-more-wrap" ref={moreRef}>
              <button
                type="button"
                className={`nav-more-btn${moreOpen ? ' open' : ''}`}
                onClick={() => setMoreOpen((o) => !o)}
                aria-expanded={moreOpen}
              >
                Más
              </button>
              {moreOpen && (
                <div className="nav-more-menu" role="menu">
                  {more.map((item) => (
                    <NavLink
                      key={item.to}
                      to={item.to}
                      end={item.end}
                      className={navClass}
                      role="menuitem"
                      onClick={() => setMoreOpen(false)}
                    >
                      {item.label}
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          )}
        </nav>

        <div className="topbar-user">
          <button type="button" className="btn-ghost" onClick={onLogout}>
            Salir
          </button>
        </div>
      </header>

      <main className={ingresosMatch ? 'main main-fluid' : 'main'}>{children}</main>
    </div>
  );
}
